import React, { useState } from 'react';
import { IVideoGallery } from '../../../galleries/video-gallery/interfaces';
import PlayAudioIcon from '../../../../ui/svg/audio/play-audio';
import Imgix from 'react-imgix';
import Gallery from '../../../galleries/gallery/gallery';
import ArrowIcon from '../../../../ui/svg/common/arrow';

interface IOnlineMasteringVideoGallery {
    videos: IVideoGallery[];
}

const OnlineMasteringVideoGallery = ({ videos }: IOnlineMasteringVideoGallery) => {
    
    const imageCDNDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();

    const [firstLoad, setFirstLoad] = useState<boolean>(false);
    const [selectedVideo, setSelectedVideo] = useState<IVideoGallery>(videos[0]);

    const getSelectedVideoIndex = (selectedVideo: IVideoGallery) => {
        if(!selectedVideo) return undefined;
        const foundIndex = videos.findIndex(item => item.youTubeCode === selectedVideo.youTubeCode);
        return foundIndex === -1 ? undefined : foundIndex;
    };

    const selectVideo = (video: IVideoGallery) => {
        if(firstLoad && video === selectedVideo ) return;

        if(!firstLoad) {
            setFirstLoad(true);
        }

        setSelectedVideo(video);
    };

    return (
        <div className="mb-12">
            {
                selectedVideo &&
                <div className="flex flex-col" data-bottom-scroll={!(videos?.length && videos?.length < 4)}>

                    <div className="w-full mb-4 ">
                        {
                            !firstLoad &&
                            <div className="w-full relative"
                                 onClick={() => {
                                     setFirstLoad(true);
                                 }}>

                                <div className="absolute left-0 top-0 mt-4 ml-6 text-white text-xl">
                                    { selectedVideo?.documentName }
                                </div>

                                <div className="absolute-center">
                                    <PlayAudioIcon width="60" height="60" color="#000000" bgColor="#ffffff"/>
                                </div>

                                <Imgix
                                    className="w-full mx-auto"
                                    src={ `${ imageCDNDomain }${ selectedVideo?.previewImage }`}
                                    sizes={"auto"}
                                    htmlAttributes={{
                                        alt: `Image for ${ selectedVideo?.documentName }`,
                                        loading: 'lazy',
                                        width: 1280,
                                        height: 720
                                    }}
                                    imgixParams={{
                                        auto: "format", // Ensures optimal image format
                                    }}
                                />
                            </div>
                        }

                        {
                            firstLoad &&
                            <div className="relative" style={{paddingTop: '56.25%'}}>
                                <iframe className="absolute inset-0 w-full h-full"
                                        id='ytplayer'
                                        title='Watch about @Model?.DocumentName.Replace("\"", "")'
                                        src={'https://www.youtube.com/embed/' + selectedVideo?.youTubeCode + '?rel=0;showinfo=0;wmode=opaque;cc_load_policy=1;iv_load_policy=' + selectedVideo?.productVideoLoadPolicy + ';autohide=1;fs=1;origin=waves.com;enablejsapi=1'}
                                        frameBorder="0"
                                        allowFullScreen>
                                </iframe>
                            </div>
                        }
                    </div>

                    {
                        videos?.length > 1 &&
                        <div className="w-full">
                            <Gallery
                                items={ videos || [] }
                                codeName={ 'fmo' }
                                duration={ 800 }
                                desktopItemsPerSlide={ 4 }
                                tableItemsPerSlide={ 4 }
                                mobileItemsPerSlide={ 2.5 }
                                jumpToItemIndex={ getSelectedVideoIndex(selectedVideo) }
                                renderItem={ (item: IVideoGallery) => {

                                    const isSelected = selectedVideo && item.youTubeCode === selectedVideo.youTubeCode;

                                    return (
                                        <button type="button" className={`h-full text-sm flex flex-col text-left items-start justify-start overflow-hidden cursor-pointer`}
                                                onClick={ () => {
                                                    selectVideo(item);
                                                }}>
                                            <div className={'relative ' + (isSelected ? 'rounded border-4 border-blue-200 text-blue-200' : 'text-gray-500 opacity-75') }
                                            >
                                                <Imgix
                                                    className="max-h-full"
                                                    src={ `${ imageCDNDomain }${ item.previewImage }`}
                                                    sizes={"auto"}
                                                    htmlAttributes={{
                                                        alt: `Image for ${ item.documentName }`,
                                                        loading: 'lazy',
                                                        width: 275,
                                                        height: 155
                                                    }}

                                                    imgixParams={{
                                                        auto: 'format', // Ensures optimal image format
                                                    }}
                                                />
                                                <div className="absolute right-0 bottom-0 py-1 px-2 mr-2 mb-2 bg-gray-700 text-white">{item.videoDurationFormat}</div>
                                            </div>
                                            <div className="mt-2 text-xs lg:text-tiny text-gray-200">{ item.documentName }</div>
                                        </button>
                                    )
                                }}
                                prevButtonArrow={
                                    <ArrowIcon
                                        width="20px"
                                        rotationAngle={90}
                                        color="#505050"
                                        style={{
                                            marginTop: '-1.5rem'
                                        }}
                                    />
                                }
                                nextButtonArrow={
                                    <ArrowIcon
                                        width="20px"
                                        rotationAngle={ -90 }
                                        color="#505050"
                                        style={{
                                            marginTop: '-1.5rem'
                                        }}
                                    />
                                }
                            />
                        </div>
                    }

                </div>
            }
        </div>
    )
};

export default OnlineMasteringVideoGallery;